import SignInService from "@services/sign-in-service";
import { getSingleInstanceByElement, initialiseComponents } from "../../core";
import Component from "../component.abstract";
import ValidatedInput from "../form/validated-input/validated-input";
import { notifyFromAlert } from "../helpers/notifs";
import SimplePassword from "../inputs/password/simple-password";
//Friendly Chaptcha lib
import {  WidgetInstance } from "friendly-challenge"; 

interface SignInProps {
  url: string;
  regexpEmail: string;
  redirectUrl: string;
  links: Links;
  captchaSiteKey: string;
  captchaIsNeeded: string;
  message: string;
}

interface Links {
  [index: string]: any;
  linkedin: string;
  google: string;
  forgotten: string;
}

export default class SignIn extends Component {
  private saveButton: HTMLButtonElement;
  private email: HTMLInputElement;
  private emailValidator: ValidatedInput;
  private password: SimplePassword;
  private remember: HTMLInputElement;
  private captchaWidget: WidgetInstance;
  private captchaSolution: string;
  private captchaIsNeeded : boolean;
  private captchaContainer : HTMLDivElement;
  private antiForgeryElement: HTMLInputElement;

  constructor(private props: SignInProps, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    this.saveButton = this.element.querySelector(".profile-button");
    // Set header message
    if (this.props.message) {
      const informalMessageDiv = this.element.querySelector("[data-sf-title]")
      if (informalMessageDiv) informalMessageDiv.innerHTML = this.props.message
    }

    // Set dynamic link
    if (this.props.links) {
      this.element.querySelectorAll("[data-sf-link]").forEach((link) => {
        link.setAttribute(
          "href",
          this.props.links[link.getAttribute("data-sf-link")]
        );
      });
    }

    this.email = this.element.querySelector("[name=email2]");
    this.email.setAttribute(
      "data-val-regex-pattern",
      this.props.regexpEmail.replace("&quot;", '"')
    );
    initialiseComponents();

    // Get input fields
    this.password = getSingleInstanceByElement(
      "SimplePassword",
      this.element.querySelector("[data-simple-password]")
    );

    this.remember = this.element.querySelector("#remember");

    // Get input validator
    this.emailValidator = getSingleInstanceByElement(
      "ValidatedInput",
      this.email
    );

    this.antiForgeryElement = <HTMLInputElement> document.querySelector("[name=__RequestVerificationToken]");

    this.element
      .querySelector(".profile-button")
      .addEventListener("click", () => {
        this.check();
      });

    document.addEventListener("keydown", (event:KeyboardEvent) => {
      if(event.key === "Enter" && (<HTMLInputElement>document.getElementById("connexion")).checked) {
        this.check();
      }
    })  

    this.element.classList.add("loaded");

    /**
     * FriendlyChaptcha
     * https://docs.friendlycaptcha.com/#/
     */
    this.captchaContainer = this.element.querySelector(".frc-captcha");
    this.captchaContainer.setAttribute("data-sitekey", this.props.captchaSiteKey);
    // Create instance for Friendly Captcha
    const captchaOptions = {
      siteKey: this.props.captchaSiteKey,
      // Force the startMode type to none to match the type requested by the API
      // https://github.com/FriendlyCaptcha/friendly-challenge/blob/88e75782228d19e718aef41fa27eceb15001589f/src/captcha.ts#L29
      startMode: "none" as 'none',
      language: "fr" as "fr",
      puzzleEndpoint: "https://eu-api.friendlycaptcha.eu/api/v1/puzzle",
      doneCallback: this.captchaDoneCallback.bind(this)
    }
    this.captchaWidget = new WidgetInstance(this.captchaContainer, captchaOptions);
    
    //Parsing is needed for unstringify
    this.captchaIsNeeded = this.props.captchaIsNeeded === "true";
  }

  captchaDoneCallback(solution: string) {
    this.captchaSolution = solution
    this.signIn(); 
  }
  check(): void {
    this.emailValidator.check();

    if (this.password.check() && this.emailValidator.check()) {
      if(this.captchaIsNeeded){
          this.captchaContainer.classList.remove("tw-hidden")
          this.captchaWidget.start()
      } else {
        this.signIn();
      }
    }
  }
  displayError(message?: string, analytics?: any): void {
    notifyFromAlert(
      {
        Icon: 2,
        Message: message
          ? message
          : "Aïe, une erreur est survenue, rechargez la page et réessayez.",
        AnalyticsTrackings: analytics ? analytics : "",
        sticky: true,
      },
      true
    );
  }
  signIn(): void {
    const data = { 
      dto: this.getFields()
    };
    
    this.saveButton.classList.add("disabled");
     const simpleProgressInstance = getSingleInstanceByElement("SimpleProgress", this.saveButton)
     simpleProgressInstance.start();

     const service = new SignInService(this.props.url);
     service.setAntiForgeryToken(this.antiForgeryElement?.value);
     service.post(data, (response:any) => {
         this.captchaIsNeeded = response.captchaIsNeeded;
         if (response.redirectUrl) {
           simpleProgressInstance.stop();
           setTimeout( () => {
             window.location.replace(response.redirectUrl);
           }, 250);
         } else {
            this.password.clear();
            simpleProgressInstance.stop();
            this.saveButton.classList.remove("disabled");
            this.displayError(response.message, response.trackingsClick ?? undefined);
         }
         if(this.captchaIsNeeded) this.captchaWidget.reset();
     })

  }

  setEmail(email: string): void {
    this.email.value = email;
  }

  getFields() {
      return {
        email: this.email.value,
        password: this.password.getValue(),
        rememberMe: this.remember.checked,
        redirectUrl: this.props.redirectUrl,
        frcCaptchaSolution: this.captchaSolution
      };
  }
}
